import { CepDetails } from "../@types/Cep";
import { findOneCepDetails } from "../services/cep";

export function useCep() {
  function getDetails(cep: string): Promise<CepDetails | null> {
    return findOneCepDetails(cep);
  }

  return { findOne: getDetails };
}
